import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import FeedbackForm from "../components/FeedbackForm";

import "../App.css"; 
import "./Home.css"; 

export default function Home() {
  const [selected, setSelected] = useState(0);
  const services = [
    {
      title: 'Electricidad',
      img: '/images/electricidad.png',
      description:
        'Profesional eléctrico disponible para instalaciones, reparaciones y mantenimiento. Calidad y seguridad garantizadas.',
      img2: '/images/electricista.jpg',
    },
    {
      title: 'Plomería',
      img: '/images/plomeria.png',
      description:
        'Soluciones de plomería: arreglos de caños, grifería, desagües y más, con respuesta rápida y materiales garantizados.',
      img2: '/images/plumber.png',
      },
    {
      title: 'Herrería',
      img: '/images/herreria.png',
      description:
        'Servicios de herrería y forja: fabricación y reparación de rejas, portones, estructuras metálicas y trabajos artísticos en hierro.',
      img2: '/images/herrero.jpg',
      },
    {
      title: 'Carpintería',
      img: '/images/carpinteria.png',
      description:
        'Trabajos en madera a medida: muebles, puertas, reparaciones y restauraciones con acabado profesional.',
      img2: '/images/carpintero.webp',
      },
    {
      title: 'Pintura',
      img: '/images/pintureria.png',
      description:
        'Pintores expertos para interiores y exteriores, asesoramiento de colores y acabados duraderos.',
      img2: '/images/pintor.jpg',
      },
    {
      title: 'Otros',
      img: '/images/Otros.png',
      description:
        '¿No encontraste tu oficio? Contanos qué otro trabajo realizás o qué te gustaría ver en la plataforma. ¡Sumemos nuevas opciones juntos!',
      img2: '/images/Others.png',
    },
  ]

  // Ya no necesitamos la inyección de estilos complejos, solo el valor base
  const serviceImgMax = 50 
  
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  // Lógica para el tamaño de las imágenes de servicio (si necesitas control dinámico, lo mantenemos en useEffect)
  useEffect(() => {
    const id = 'service-img-size-override'
    if (document.getElementById(id)) return
    const style = document.createElement('style')
    style.id = id
    // Mantenemos el CSS para ajustar el tamaño de las imágenes de servicio dinámicamente
    style.innerHTML = `
      .service img { max-width: ${serviceImgMax}px !important; width: auto !important; }
      @media (max-width: 900px) {
        .service img { max-width: ${Math.max(serviceImgMax - 40, 80)}px !important; }
      }
      @media (max-width: 600px) {
        .service img { max-width: 100% !important; }
      }
    `
    document.head.appendChild(style)
    return () => document.getElementById(id)?.remove()
  }, [serviceImgMax])


  const buttonStyle = {
    backgroundColor: '#00796B',
    border: 'none',
    padding: '12px 28px',
    borderRadius: '8px',
    marginTop: '25px',
    cursor: 'pointer',
    fontWeight: 'bold',
    color: '#FAFAFA',
    fontSize: '1rem',
    transition: 'background-color 0.2s ease-in-out, transform 0.2s ease',
  }

  const buttonHover = {
    backgroundColor: '#004D40',
    transform: 'scale(1.05)',
  }

  return (
       <>
          
          <Navbar />
    
          {/* HERO PRINCIPAL */}
          <section
            id="inicio"
            className="hero-section" // <-- CLASE
          >
            <div
              className="hero-content-wrapper" // <-- CLASE
            >
              {/* Texto y botón */}
              <div
                className="hero-text-container" // <-- CLASE
              >
                <h1>
                  Conectamos manos que saben con oportunidades que esperan.
                </h1>
                <p>
                  Una comunidad donde los oficios encuentran trabajo y los clientes confianza.
                </p>
                {!token && (
                  <button
                    style={buttonStyle}
                    onMouseOver={(e) => Object.assign(e.target.style, buttonHover)}
                    onMouseOut={(e) => Object.assign(e.target.style, buttonStyle)}
                    onClick={() => navigate("/login")}
                  >
                    Iniciar sesión
                  </button>
                )}
              </div>
    
              {/* Imagen decorativa */}
              <div
                className="hero-image-container" // <-- CLASE
              >
                <img
                  src="/images/hero.png"
                  alt="Oficios en acción"
                />
              </div>
            </div>
          </section>
    
          {/* SERVICIOS */}
          <section
            id="servicios"
            className="servicios-section" // <-- CLASE
          >
            {/* Se elimina el bloque <style> */}
    
            <div className="servicios-container" role="list">
              {services.map((s, i) => (
                <button
                  key={s.title}
                  type="button"
                  className={`service ${selected === i ? 'selected' : ''}`}
                  onClick={() => setSelected(i)}
                  aria-pressed={selected === i}
                >
                  <img src={s.img} alt={s.title} />
                  <p className="title">{s.title}</p>
                </button>
              ))}
            </div>
    
            {/* Tarjeta grande con imagen y descripción */}
            <div className="service-card">
              <div className="image-container">
                <img
                  src={services[selected].img2}
                  alt={services[selected].title}
                />
                <div className="image-overlay">
                  <div className="overlay-text">{services[selected].title}</div>
                </div>
              </div>
    
              <div className="service-info">
                <h3>{services[selected].title}</h3>
                <p>{services[selected].description}</p>
              </div>
            </div>
          </section>
    
    {/* CÓMO FUNCIONA */}
    <section
      id="como-funciona"
      className="how-section" // <-- CLASE
    >
      {/* Se elimina el bloque <style> */}
    
      <div className="how-container">
        <h2>Cómo funciona OficiAR</h2>
        <p>
          Nuestra plataforma conecta a quienes necesitan ayuda con los profesionales que saben hacer el trabajo.  
          Así de simple, transparente y rápido.
        </p>
    
        <div className="steps-wrapper">
          {/* Paso 1 */}
          <motion.div
            className="step"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <img src="/images/registrar.png" alt="Registro" />
            <h3>1. Registrate</h3>
            <p>
              Creá tu cuenta gratuita como <strong>empleador</strong> o <strong>trabajador</strong>.  
              En pocos pasos tendrás tu perfil listo para empezar.
            </p>
          </motion.div>
    
          {/* Paso 2 */}
          <motion.div
            className="step"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }}
          >
            <img src="/images/buscar.png" alt="Búsqueda" />
            <h3>2. Buscá o publicá trabajos</h3>
            <p>
              Si necesitás ayuda, publicá lo que buscás.  
              Si ofrecés un oficio, explorá las oportunidades disponibles cerca tuyo.
            </p>
          </motion.div>
    
          {/* Paso 3 */}
          <motion.div
            className="step"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.3, ease: "easeOut" }}
          >
            <img src="/images/conectar.png" alt="Conexión" />
            <h3>3. Conectá y trabajá</h3>
            <p>
              Chateá, coordiná y concretá el trabajo de forma directa y segura.  
              Sin intermediarios, con confianza y transparencia.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
    
    
    {/* QUIÉNES SOMOS */}
    <section
      id="nosotros"
      className="about-section" // <-- CLASE
    >
      {/* Se elimina el bloque <style> */}
    
      <div className="about-container">
        <div className="about-text">
          <h2>Quiénes somos</h2>
          <p>
            Somos un equipo apasionado por la tecnología y el trabajo genuino.
            Nuestra misión es conectar oficios con oportunidades, creando una comunidad
            digital donde la confianza, la calidad y la cercanía son lo primero.
          </p>
          <p>
            Creemos en el valor del esfuerzo, la colaboración y la innovación aplicada
            al trabajo real — ese que se hace con las manos y el corazón.
          </p>
        </div>
    
        <div className="about-image">
          <img src="/images/aboutus.jpg" alt="Equipo de OficiAR" />
        </div>
      </div>
    </section>
    
    {/* CONTACTO / SUGERENCIAS */}
    <section
      id="contacto"
      className="feedback-section" // <-- CLASE
    >
      {/* Se elimina el bloque <style> */}
    
      <div className="feedback-container">
        <h2>Tu opinión importa 💬</h2>
        <p>
          Queremos mejorar OficiAR con vos. Contanos qué te parece la plataforma o
          qué te gustaría ver en futuras versiones.
        </p>
    
        <FeedbackForm />
      </div>
    </section>
    
        </>
    )
}